import React from 'react'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import icon from '@assets/images/hil/icon.svg'
import s1Image from '@assets/images/hil/s1.jpeg'
import s2Image from '@assets/images/hil/s2.jpg'
import location from '@assets/images/hil/location.svg'
import people from '@assets/images/hil/people.svg'
import CustomLink from '@shared/components/customLink'

function HILInfo() {
  const HILData = [
    {
      label: 'Founded',
      value: '2013'
    },
    {
      label: 'First Season',
      value: '2013'
    },
    {
      label: 'Administrator',
      value: 'Hockey India'
    },
    {
      label: 'Country',
      value: 'India'
    },
    {
      label: 'Headquarters',
      value: 'New Delhi'
    },
    {
      label: 'Total Teams',
      value: '12'
    },
    {
      label: 'Recent Champion',
      value: 'Kalinga Lancers (2017)'
    },
    {
      label: 'Tournament Format',
      value: 'Double round-robin Knockout'
    }
  ]
  return (
    <>
      <div className={styles.leaguePointsTable}>
        <div className={`d-flex align-items-center ${styles.tableBanner}`}>
          <div>
            <MyImage className={styles.logo} alt="HIL Icon" src={icon} height={31} width={58} />
          </div>
        </div>
        <div className={styles.tableCntr}>
          {HILData.map((item, index) => (
            <div key={index} className={styles.tableRow}>
              <div className={styles.tableLabel}>{item.label}</div>
              <div className={item.label === 'Founded' ? styles.pinkValue : styles.tableValue}>{item.value}</div>
            </div>
          ))}
        </div>
      </div>
      <div>
        <h4 className="font-bold">Venues</h4>
        <div className={styles.venueContainer}>
          <div className="w-100 d-flex justify-content-between align-item-center gap-2">
            <div className="w-75">
              <MyImage src={s1Image} alt="Stadium Image" height={90} width={123} className={styles.stadiumImage} />
            </div>
            <div className="w-100">
              <CustomLink href={'https://www.oneturf.news/hockey/hockey-india-league-all-about-the-birsa-munda-hockey-stadium-in-rourkela'}>
                <div className={`${styles.stadiumTitle}`}>Birsa Munda International Hockey stadium</div>
              </CustomLink>
              <div className="d-flex justify-content-center gap-2 mt-2">
                <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
                  <MyImage src={location} alt="Location" className={styles.loImg} />
                  <p className="mb-0">Rourkela</p>
                </div>
                <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
                  <MyImage src={people} alt="People" className={styles.loImg} />
                  <p className="mb-0">20,011</p>
                </div>
              </div>
            </div>
          </div>
          <div className="w-100 d-flex justify-content-between align-item-center gap-2">
            <div className="w-75">
              <MyImage src={s2Image} alt="Stadium Image" height={90} width={123} className={styles.stadiumImage} />
            </div>
            <div className="w-100">
              <CustomLink
                href={
                  'https://www.oneturf.news/hockey/hockey-india-league-2024-all-about-marang-gomke-jaipal-singh-astroturf-hockey-stadium'
                }>
                <div className={`${styles.stadiumTitle} cursor-pointer`}>Marang Gomke Jaipal Singh Astro Turf Hockey Stadium</div>
              </CustomLink>
              <div className="d-flex justify-content-center gap-2 mt-2">
                <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
                  <MyImage src={location} alt="Location" className={styles.loImg} />
                  <p className="mb-0">Ranchi</p>
                </div>
                <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
                  <MyImage src={people} alt="People" className={styles.loImg} />
                  <p className="mb-0">5000</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HILInfo
